import LOAD_DEFAULT from '@/brain/record/distributor/load-default-distributor'

const state = {
  defaultDistributor: null
}
const getters = {
  DEFAULT_DISTRIBUTOR_ID: state => state.defaultDistributor.map(d => d._id)
}
const mutations = {
  DEFAULT_DISTRIBUTOR: (state, defaultDistributor) => { Object.assign(state, { defaultDistributor }) }
}

const actions = {
  LOAD_DEFAULT
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/record/distributor/state/index.js